var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg2 = function Svg2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#2_svg__a)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.85,
    d: "M2.259 9.188 2.26.608h17.463v11.407H5.152M4.058 3.58h7.413M4.058 5.393h7.413m.55 2.688h5.473m-5.472 1.812h5.472M1.155 19.73l-.553-3.31 7.628.018.588 3.292M2.3 9.474l3.34-3.05c.916-.028 1.017 1.94.444 2.484L4.77 10.16c.837 1.503.443 1.83-.483 3.104m-2.566 2.74L.642 9.912C.455 8.391.922 6.811 2.1 5.97m5.779 6.166c.073.778.007 1.204-.592 1.65-.546.406-.824.815-.75 1.361.05.364.168.724.262 1.25m8.584-13.631h2.228v2.674h-2.228z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "2_svg__a",
    x1: 10.163,
    x2: 10.163,
    y1: 0.608,
    y2: 19.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })))));
};
export default Svg2;